import * as React from 'react';
import s from '../ChangePlanModal.scss';
import { Text } from 'wix-style-react';
import { ChangePlanPlanDetails } from '../../../ChangePlanTypes';
import { Translation } from 'react-i18next';
import { DateTimeFormatter } from '@wix/premium-react-text';

interface PlanRenwalProps {
  planDetails: ChangePlanPlanDetails;
  amount?: number;
  isCurrentPlan: boolean;
}

export const PlanRenwal: React.FC<PlanRenwalProps> = ({
  planDetails,
  amount,
  isCurrentPlan,
}) => {
  return (
    <DateTimeFormatter
      dateFormat='longMonth'
      render={(formatDate) => (
        <Translation>
          {(t) => (
            <div className={s.extendBox} data-testid='renews_on'>
              <Text size='small'>
                {t('change_plan.change_plan_modal.renews_on', {
                  date: formatDate(planDetails.endOfPeriod),
                })}
              </Text>
              {!isCurrentPlan && (
                <Text size='small' skin='success' data-testid='days_added'>
                  &nbsp;
                  {t('change_plan.change_plan_modal.renew_for_days', {
                    amount,
                  })}
                </Text>
              )}
            </div>
          )}
        </Translation>
      )}
    />
  );
};
